import AppLayout from '../components/AppLayout';
import { Button } from '../components/ui/button';
import { CreditCard, Wifi, Lock, Globe, Bell } from 'lucide-react';

const CardsPage = () => {
  return (
    <AppLayout>
      <div className="min-h-screen lg:min-h-0 pb-24 lg:pb-0">
        {/* Header */}
        <div className="p-6 lg:p-0 lg:mb-8">
          <h1 className="text-2xl lg:text-3xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>Cards</h1>
          <p className="text-muted-foreground">Virtual and physical cards</p>
        </div>
        
        <div className="px-6 lg:px-0">
          <div className="bg-card border border-white/10 rounded-2xl p-8 text-center max-w-2xl lg:mx-0">
            {/* Card Preview */}
            <div className="relative w-full max-w-sm mx-auto mb-8">
              <div className="aspect-[1.586/1] bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] rounded-2xl p-6 border border-white/10 shadow-2xl">
                <div className="flex items-center justify-between mb-8">
                  <div className="w-12 h-8 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded" />
                  <Wifi className="w-6 h-6 text-white/50 rotate-90" />
                </div>
                <div className="text-left mb-6">
                  <p className="text-white/50 text-xs mb-1">Card Number</p>
                  <p className="text-white font-mono tracking-widest">---- ---- ---- ----</p>
                </div>
                <div className="flex items-end justify-between">
                  <div className="text-left">
                    <p className="text-white/50 text-xs mb-1">Card Holder</p>
                    <p className="text-white text-sm font-medium">YOUR NAME HERE</p>
                  </div>
                  <div className="text-right">
                    <p className="text-white/50 text-xs mb-1">Expires</p>
                    <p className="text-white text-sm font-medium">--/--</p>
                  </div>
                </div>
                <div className="absolute top-4 right-4">
                  <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
                    <span className="text-white text-xs font-bold">L1</span>
                  </div>
                </div>
              </div>
            </div>
            
            <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Cards are coming soon</h2>
            <p className="text-muted-foreground mb-6 max-w-md mx-auto">Get virtual and physical cards to spend your LekeeWallet balance anywhere in the world.</p>
            <Button className="bg-primary hover:bg-red-600 text-white font-semibold glow-primary mb-8">
              <Bell className="w-5 h-5 mr-2" />Get Notified
            </Button>
            
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-lg lg:max-w-none mx-auto text-left">
              {[
                { icon: CreditCard, label: 'Online Payments', desc: 'Pay anywhere online' },
                { icon: Globe, label: 'International', desc: 'Works worldwide' },
                { icon: Lock, label: 'Instant Freeze', desc: 'Control your card' },
                { icon: Wifi, label: 'Contactless', desc: 'Tap to pay' },
              ].map(({ icon: Icon, label, desc }) => (
                <div key={label} className="bg-white/5 rounded-xl p-4">
                  <Icon className="w-6 h-6 text-primary mb-2" />
                  <p className="font-medium text-sm">{label}</p>
                  <p className="text-xs text-muted-foreground">{desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default CardsPage;
